<template>
	<div class="page-content">
		
		<div class="logo-wrapper">
			<div class="logo adequation"><img src="@/assets/img/logo-adequation.png" alt="ADEQUATION"></div>
			<div class="logo cdc"><img src="@/assets/img/cdc-habitat.png" alt="CDC Habitat"></div>
		</div>

		<div class="main-name">
			<!-- PREFIX -->
			<p class="main-name__upper title-segment">{{title}}</p>
			<!-- <p v-if ="active_study.segment.code =='LAC'" class="main-name__upper title-segment">Etude flash - Libre abordable contractualisé</p>
			<p v-if ="active_study.segment.code =='LLI'" class="main-name__upper title-segment">Etude flash - Locatif intermédiaire</p>
			-->
			<div class="main-name__address-row">
				<el-textarea class="main-name__upper" :parent_data="active_study.etudeData" property="titre" :editable="true" />
				<span class="main-name__address-row__separator"> - </span>
				<el-textarea class="main-name__upper" :parent_data="active_study.etudeData" property="sous_titre" :editable="true" />
			</div>
			<el-textarea class="main-name__upper" :parent_data="active_study.projet" property="promoteur" :editable="false" />
			
			<!-- SUFFIX -->
			<p v-if="active_study.etudeType.slug == 'actu'" class="title-type">{{active_study.etudeType.nom}}</p>
		</div>

		<div class="inner-content">
			<div class="main-title" style="margin: 0px;">
				<p class="title green_text"><span class="no green_bg">1</span>  Synthèse et positionnement locatif et prix de vente du projet</p>
			</div>

			<section-synthese main_color="dark_red" />
		</div>
	
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import SectionSynthese from "@/components/study/editor/pages/sections/section-synthese";

export default {
	name: "page-garde",
	mixins: [ PageMixin ],
	data: function () {
		return {
			form: {
				title: ""
			}
		};
	},
	computed: {
		...mapGetters([ "active_study" ]),
		title: function () {
			if(this.active_study.etudeType.slug == "grand_projet")
				return "Etude Flash Grand Projet - LLI / LAC";
			else
				return "Etude flash - LLI / LAC";
		}
	},
	components: {
		SectionSynthese
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.logo-wrapper
	padding 30px
	display flex
	justify-content space-between

.logo
	height 40px
	width auto
	
	img
		height 100%
		width auto
.title-segment
	font-size 20px
.title-type
	font-size 14px
	text-align right
	font-style italic
	position absolute
	right 16px
	top 4px
.main-name
	padding 5px
	text-align center
	font-size 18px
	line-height 28px
	font-weight bold
	background-color main_color
	color #fff
	z-index 10001
	
	.el-textarea
		line-height 28px

	&__upper
		text-transform uppercase

	&__address-row
		display flex
		justify-content center
		align-items flex-start
		text-align left

		&__separator
			margin-left 10px
			margin-right 10px

</style>
